import { Component } from '@angular/core';
import { membersuiteRevenueRecognitionScheduleEntryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Revenue Recognition Schedule Entries') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiterevenuerecognitionscheduleentry-form',
    templateUrl: './membersuiterevenuerecognitionscheduleentry.form.component.html'
})
export class membersuiteRevenueRecognitionScheduleEntryFormComponent extends BaseFormComponent {
    public record!: membersuiteRevenueRecognitionScheduleEntryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

